import { Action } from 'redux';
import { SidebarSelection } from '@trucktrax/trucktrax-common';
import { PayloadAction } from '../../types';
import {
  SET_OPEN_STATE_MAP,
  SET_SIDEBAR_SELECTED,
  TOGGLE_DRIVERS_DROPDOWN_IS_OPEN,
  TOGGLE_TRUCKS_DROPDOWN_IS_OPEN,
  TOGGLE_EXTERNAL_TRUCKS_DROPDOWN_IS_OPEN,
  TOGGLE_GUIDE_DROPDOWN_IS_OPEN,
} from '../../constants/actionConstants';
import { GEOTRAX_PAGE_SELECTED, MESSAGE_SELECTED } from '../../constants/appConstants';
import { NavItem } from '../../constants/navConstants';
import { currentPath } from '../../util/appUtil';

export const sidebar = (
  state = { sidebarTitle: MESSAGE_SELECTED, isSelected: false },
  action: { type: string; payload: SidebarSelection },
) => {
  switch (action.type) {
    case SET_SIDEBAR_SELECTED:
      return {
        sidebarTitle: action?.payload?.sidebarTitle ?? state.sidebarTitle,
        isSelected: action?.payload?.isSelected ?? state.isSelected,
      } as SidebarSelection;
    default:
      return state as SidebarSelection;
  }
};

export const getCurrentPageUrl = () => ({
  navRoute: currentPath(),
});

export const geotraxPage = (
  state = getCurrentPageUrl(),
  action: { type: string; payload: NavItem },
) => {
  switch (action.type) {
    case GEOTRAX_PAGE_SELECTED:
      return action.payload;
    default:
      return state;
  }
};

export const trucksDropdownIsOpen = (
  state = true,
  action: Action<'TOGGLE_TRUCKS_DROPDOWN_IS_OPEN'>,
) => {
  switch (action.type) {
    case TOGGLE_TRUCKS_DROPDOWN_IS_OPEN:
      return !state;
    default:
      return state;
  }
};

export const externalTrucksDropdownIsOpen = (
  state = true,
  action: Action<'TOGGLE_EXTERNAL_TRUCKS_DROPDOWN_IS_OPEN'>,
) => {
  switch (action.type) {
    case TOGGLE_EXTERNAL_TRUCKS_DROPDOWN_IS_OPEN:
      return !state;
    default:
      return state;
  }
};

export const guideDropdownIsOpen = (
  state = true,
  action: Action<'TOGGLE_GUIDE_DROPDOWN_IS_OPEN'>,
) => {
  switch (action.type) {
    case TOGGLE_GUIDE_DROPDOWN_IS_OPEN:
      return !state;
    default:
      return state;
  }
};

export const driversDropdownIsOpen = (
  state = true,
  action: Action<'TOGGLE_DRIVERS_DROPDOWN_IS_OPEN'>,
) => {
  switch (action.type) {
    case TOGGLE_DRIVERS_DROPDOWN_IS_OPEN:
      return !state;
    default:
      return state;
  }
};

type OpenByIndexMap = { [index: number]: boolean };
export const openStateMap = (
  state: OpenByIndexMap = {},
  action: PayloadAction<{ [key: number]: boolean }, 'SET_OPEN_STATE_MAP'>,
): OpenByIndexMap => {
  switch (action.type) {
    case SET_OPEN_STATE_MAP:
      return { ...action.payload };
    default:
      return state;
  }
};
